import clsx from "clsx";
import React from "react";
import { User } from "types";
import { useResource } from "../../../hooks/useResource";
import { NoTranslate } from "../../Common/NoTranslate";

interface ReservationistNameProps {
    id: string | null;
    name?: string | null;
    fullName?: boolean;
    reservationistExists?: boolean;
    onNameClick?: (id: string) => void;
}

export const ReservationistName = ({
    id,
    name,
    fullName,
    reservationistExists = true,
    onNameClick,
}: ReservationistNameProps) => {
    const { data: reservationist } = useResource<User>(["users", id], null, { enabled: reservationistExists });
    name = name ?? reservationist?.name;

    if (!name) {
        return <NoTranslate>--</NoTranslate>;
    }

    const [firstName, lastName] = name.split(" ") ?? [""];

    const handleOnNameClick = () => {
        if (id && onNameClick) {
            onNameClick(id);
        }
    };

    if (fullName) {
        return (
            <NoTranslate className={clsx(onNameClick && "cursor-pointer hover:underline")} onClick={handleOnNameClick}>
                {firstName} {lastName && `${lastName}`}
            </NoTranslate>
        );
    }

    return (
        <NoTranslate className={clsx(onNameClick && "cursor-pointer hover:underline")} onClick={handleOnNameClick}>
            {firstName} {lastName && `${lastName.charAt(0)}.`}
        </NoTranslate>
    );
};
